
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1504Dialog extends Serenity.EntityDialog<Report_1504Row, any> {
        protected getFormKey() { return Report_1504Form.formKey; }
        protected getIdProperty() { return Report_1504Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1504Row.localTextPrefix; }
        protected getNameProperty() { return Report_1504Row.nameProperty; }
        protected getService() { return Report_1504Service.baseUrl; }
        protected getDeletePermission() { return Report_1504Row.deletePermission; }
        protected getInsertPermission() { return Report_1504Row.insertPermission; }
        protected getUpdatePermission() { return Report_1504Row.updatePermission; }

        protected form = new Report_1504Form(this.idPrefix);

    }
}